<template>
  <div class="select-column-main">
    <div class="select-column-inner">
      <div class="selected-display" :class="{ active: isOpenOption }" @click="isOpenOption = !isOpenOption" :id="idColumn">
        <div class="d-flex">
          <div v-if="!selectedValue" class="w-100 text-selected pe-3">{{ placeholder }}</div>
          <div v-else class="w-100 text-selected pe-3">{{ selectedValue }}</div>
          <div class="btn-open-option">
            <arrow-box-icon class="arrow-box-icon" />
          </div>
        </div>
      </div>
      <div v-if="isOpenOption" class="option-display" :class="{ active: isOpenOption }">
        <div v-if="optionList.length > 0" class="option-display-inner">
          <div
            class="item-list"
            v-for="(item, index) in optionList"
            :key="index"
            @click="selectedItemColumn(item)"
            :class="{ selected: item[label] == selectedValue }"
          >
            {{ item[label] }}
          </div>
        </div>
        <div v-else class="option-display-inner empty">
          <div class="item-list text-center">
            {{ t('component.filter_table.components.select_column.empty') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import ArrowBoxIcon from '@/assets/icons/base/table/ArrowBoxIcon.vue';

import useSelectColumn from '../hooks/useSelectColumn';

interface Props {
  isSelected: boolean;
  options: any;
  selectValue: any;
  label: string;
  placeholder: string;
  idColumn: string;
}
const props = withDefaults(defineProps<Props>(), {
  placeholder: '- เลือก -',
});

defineEmits(['on-selected']);

const { t } = useI18n();
const { selectedValue, isOpenOption, optionList, selectedItemColumn } = useSelectColumn(props);
</script>

<style lang="scss" scoped>
@import '@/assets/styles/base/filter-table/select-column.scss';
</style>
